<template>
    <RPBasicCardVue
        class="rp-logout-card"
        @click="$emit('click')"
        :isheader="false"
	    >
        <span slot="header"> </span>
        <div slot="body" class="rp-logout-card__body">
            <img src="@/assets/img/logout.png" height="20" width="20" />
            <span> {{$t('loginScreen.logout')}} </span>
        </div>
   </RPBasicCardVue>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.rp-logout-card {
    margin: 16px;
    cursor: pointer;
    .rp-logout-card__body {
        display: flex;
        align-items: center;
        font-size: 18px;
        padding: 20px;
        font-family: $font;
        @include for-size(tablet-landscape-up) {
            padding: 20px 40px;
        }
        @include for-size(desktop-up){
            font-weight: 500;
        	padding: $desktopPadding;
            font-size: 26px;
        }
        img {
            margin-right: 10px;
            @include for-size(desktop-up){
                height: 23px;
                width: 23px;
            }
        }
    }
}
</style>
